import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import HomePage from '../containers/HomePage';
import NotFoundPage from '../components/NotFoundPage';
import ControlPanelPage from "../containers/ControlPanelPage";
import UserProfile from "../containers/UserProfile";

class MainRoutes extends Component {

    render() {
        return (
            <Switch>
                <Route path="/" component={HomePage} exact />
                <Route path="/panel-control" component={ControlPanelPage}/>
                <Route path="/perfil-usuario" component={UserProfile} exact/>
                <Route component={NotFoundPage}/>
            </Switch>
        );
    }
}

export default MainRoutes;


// WEBPACK FOOTER //
// ./src/routes/MainRoutes.js